import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SecurityPage from './pages/SecurityPage';

const SecurityRoutes = () => (
  <Routes>
    <Route path="/" element={<SecurityPage />} />
  </Routes>
);

export default SecurityRoutes;
